<template>
  <base-auth-form />
</template>

<script>
import BaseAuthForm from '@/components/auth/BaseAuthForm'

export default {
  components: {
    BaseAuthForm,
  }
}
</script>

<style lang="scss" scoped></style>
